import React from 'react';

import './SliderGoldPicker.sass'

import Slider from 'rc-slider';
import cx from 'classnames';
import GoldPickerInput from "./GoldPickerInput";

export default class SliderGoldPicker extends React.PureComponent {
  render() {
    const {min, max, value, onChange, unitLabel, isShowCustomInput} = this.props;

    const renderCustomInputOrLabel = () => {
      if (isShowCustomInput) {
        return (
          <GoldPickerInput
            min={min}
            max={max}
            unitLabel={unitLabel}
            value={value}
            onChange={onChange}/>
        )
      } else {
        return (
          <div className="gold-slider__quantity">
            <div className="gold-slider__quantity-value">
              {value}
            </div>
            <div className="gold-slider__quantity-units">
              {unitLabel}
            </div>
          </div>
        )
      }
    }

    return (
      <div className={cx('gold-slider', isShowCustomInput && 'gold-slider-block')}>
        {renderCustomInputOrLabel()}
        <div className="gold-slider__slider">
          <Slider
            min={min}
            max={max}
            value={value}
            onChange={onChange}
          />
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/productVariants/goldPickers/SliderGoldPicker.js